const instance = new URLSearchParams(location.search).get("instance") || sessionStorage.getItem("wix-instance") || "";
if (instance) sessionStorage.setItem("wix-instance", instance);

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (instance) headers.set("X-Wix-Instance", instance);
  const response = await fetch(path, {...init, headers});
  const body = await response.json<{error?: string; code?: string} & T>().catch(() => ({} as {error?: string} & T));
  if (!response.ok) throw new Error(body.error || "The request could not be completed");
  return body;
}

export const jsonRequest = (method: string, body?: unknown): RequestInit => ({
  method,
  headers: {"Content-Type": "application/json"},
  ...(body === undefined ? {} : {body: JSON.stringify(body)}),
});

export async function toWebp(file: File): Promise<Blob> {
  if (!file.type.startsWith("image/")) throw new Error("Choose an image file");
  const bitmap = await createImageBitmap(file);
  const maximum = 2400;
  const scale = Math.min(1, maximum / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const context = canvas.getContext("2d");
  if (!context) throw new Error("This browser could not prepare the image");
  context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("This image could not be converted")), "image/webp", 0.86));
}

export function money(cents: number) { return new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 0}).format(cents / 100); }

